import i18n from '@/i18n'
import ManagementLayout from '../layout/managementLayout'
import surveyRoute from './survey/route'
import tagRoute from './tag/route'
import taskRoute from './task/route'
import micrositeRoute from './microsite/route'
import campaignRoute from './campaign/route'
import reportRoute from './report/route'

const basePath = '/v-admin/crm-management'

export const crmMenuRoutes = [
  surveyRoute,
  tagRoute,
  taskRoute,
  micrositeRoute,
  campaignRoute,
  reportRoute
]

const permission = {
  strict: false,
  isMatchAnd: true,
  any: [
    ['PERM_MICROSITE_CAMPAIGN_MANAGEMANT', 'PREMIUM_MICROSITE_CAMPAIGN_MANAGEMENT'],
    ['PERM_CANDIDATE_SURVEY_MANAGEMENT', 'PREMIUM_PREFERENCE_SURVEY_MANAGEMENT'],
    ['PERM_TAG_MANAGEMANT', 'PREMIUM_TAG_MANAGEMENT']
  ]
}

export default {
  // no name because it has default child
  // only first default child can be accessed through the path
  path: `${basePath}`,
  component: ManagementLayout,
  meta: {
    isInclude: true,
    isAllInclude: true,
    isNewPage: true,
    isRootBreadcrumb: true,
    permission: permission,
    titleI18nKey: 'admin.crm.title.management',
    tab: {
      get label () {
        return i18n.t('admin.crm.tab')
      }
    }
  },
  children: crmMenuRoutes
}
